export declare namespace IdleSessionModalTokenSections {
	interface Title {
		color: string;
	}

	interface Text {
		color: string;
	}
}

export type IdleSessionModalTokens = {
	title: IdleSessionModalTokenSections.Title;
	text: IdleSessionModalTokenSections.Text;
};

export const title: IdleSessionModalTokenSections.Title = { color: '{named.idle.session.modal.title.color}' };

export const text: IdleSessionModalTokenSections.Text = { color: '{named.idle.session.modal.text.color}' };

/** Idle-session warning dialog text colours (`css/idleSessionModal`). */
export default {
	title,
	text,
} satisfies IdleSessionModalTokens;
